import script from "./pc-module-trend-6.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-trend-6.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-trend-6.vue?vue&type=style&index=0&id=dcc081d0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dcc081d0"]])

export default __exports__